import React from 'react';
interface EyebrowProps {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
}
/** Eyebrow monoespaciado con el prefijo ">>>" del ejemplo. */
export function Eyebrow({
  children,
  tone = 'light'
}: EyebrowProps) {
  const isDark = tone === 'dark';
  return <div className={`mb-4 font-mono text-[12px] font-bold uppercase tracking-[2px] ${isDark ? 'text-ink' : 'text-camel'}`} data-id="element-31">
      <span className="mr-1.5 text-camel" aria-hidden="true" data-id="element-32">
        &gt;&gt;&gt;
      </span>
      {children}
    </div>;
}